import React from "react";
import { MessageCircle } from "lucide-react";
import { CLINIC } from "@/lib/clinicInfo";

/**
 * WhatsAppFAB — floating action button visible on every public page.
 * Opens WhatsApp with a pre-filled greeting so patients can start a chat instantly.
 * The clinic can then use WhatsApp Business Auto-Reply to send timings + booking link
 * (external setup — done inside the WhatsApp Business app on the clinic's phone).
 */
export default function WhatsAppFAB() {
  return (
    <a
      href={CLINIC.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Nehchal Eye Centre on WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-40 inline-flex items-center gap-2 rounded-full bg-[#25d366] text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all px-4 py-3 sm:px-5 sm:py-3.5"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="h-5 w-5" fill="currentColor" strokeWidth={0} />
      <span className="hidden sm:inline text-sm font-medium">Chat on WhatsApp</span>
      <span className="sr-only">Open WhatsApp chat with Nehchal Eye Centre</span>
    </a>
  );
}
